module.exports = __webpack_public_path__ + "static/media/stone.719cf036.gif";